/**
 * @fileoverview gRPC-Web generated client stub for promptoverridesources
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: promptoverridesources/promptoverridesources.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.promptoverridesources = require('./promptoverridesources_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.promptoverridesources.PromptOverrideSourcesClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.promptoverridesources.PromptOverrideSourcesPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.promptoverridesources.ListPromptOverrideSourcesResponse>}
 */
const methodDescriptor_PromptOverrideSources_ListPromptOverrideSources = new grpc.web.MethodDescriptor(
  '/promptoverridesources.PromptOverrideSources/ListPromptOverrideSources',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.promptoverridesources.ListPromptOverrideSourcesResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.promptoverridesources.ListPromptOverrideSourcesResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.promptoverridesources.ListPromptOverrideSourcesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.promptoverridesources.ListPromptOverrideSourcesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.promptoverridesources.PromptOverrideSourcesClient.prototype.listPromptOverrideSources =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/promptoverridesources.PromptOverrideSources/ListPromptOverrideSources',
      request,
      metadata || {},
      methodDescriptor_PromptOverrideSources_ListPromptOverrideSources,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.promptoverridesources.ListPromptOverrideSourcesResponse>}
 *     Promise that resolves to the response
 */
proto.promptoverridesources.PromptOverrideSourcesPromiseClient.prototype.listPromptOverrideSources =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/promptoverridesources.PromptOverrideSources/ListPromptOverrideSources',
      request,
      metadata || {},
      methodDescriptor_PromptOverrideSources_ListPromptOverrideSources);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.promptoverridesources.CreatePromptOverrideSourceRequest,
 *   !proto.promptoverridesources.CreatePromptOverrideSourceResponse>}
 */
const methodDescriptor_PromptOverrideSources_CreatePromptOverrideSource = new grpc.web.MethodDescriptor(
  '/promptoverridesources.PromptOverrideSources/CreatePromptOverrideSource',
  grpc.web.MethodType.UNARY,
  proto.promptoverridesources.CreatePromptOverrideSourceRequest,
  proto.promptoverridesources.CreatePromptOverrideSourceResponse,
  /**
   * @param {!proto.promptoverridesources.CreatePromptOverrideSourceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.promptoverridesources.CreatePromptOverrideSourceResponse.deserializeBinary
);


/**
 * @param {!proto.promptoverridesources.CreatePromptOverrideSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.promptoverridesources.CreatePromptOverrideSourceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.promptoverridesources.CreatePromptOverrideSourceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.promptoverridesources.PromptOverrideSourcesClient.prototype.createPromptOverrideSource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/promptoverridesources.PromptOverrideSources/CreatePromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_PromptOverrideSources_CreatePromptOverrideSource,
      callback);
};


/**
 * @param {!proto.promptoverridesources.CreatePromptOverrideSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.promptoverridesources.CreatePromptOverrideSourceResponse>}
 *     Promise that resolves to the response
 */
proto.promptoverridesources.PromptOverrideSourcesPromiseClient.prototype.createPromptOverrideSource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/promptoverridesources.PromptOverrideSources/CreatePromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_PromptOverrideSources_CreatePromptOverrideSource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlRequest,
 *   !proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlResponse>}
 */
const methodDescriptor_PromptOverrideSources_GetPromptOverrideSourceDownloadUrl = new grpc.web.MethodDescriptor(
  '/promptoverridesources.PromptOverrideSources/GetPromptOverrideSourceDownloadUrl',
  grpc.web.MethodType.UNARY,
  proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlRequest,
  proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlResponse,
  /**
   * @param {!proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlResponse.deserializeBinary
);


/**
 * @param {!proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.promptoverridesources.PromptOverrideSourcesClient.prototype.getPromptOverrideSourceDownloadUrl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/promptoverridesources.PromptOverrideSources/GetPromptOverrideSourceDownloadUrl',
      request,
      metadata || {},
      methodDescriptor_PromptOverrideSources_GetPromptOverrideSourceDownloadUrl,
      callback);
};


/**
 * @param {!proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.promptoverridesources.GetPromptOverrideSourceDownloadUrlResponse>}
 *     Promise that resolves to the response
 */
proto.promptoverridesources.PromptOverrideSourcesPromiseClient.prototype.getPromptOverrideSourceDownloadUrl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/promptoverridesources.PromptOverrideSources/GetPromptOverrideSourceDownloadUrl',
      request,
      metadata || {},
      methodDescriptor_PromptOverrideSources_GetPromptOverrideSourceDownloadUrl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.promptoverridesources.DeletePromptOverrideSourceRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PromptOverrideSources_DeletePromptOverrideSource = new grpc.web.MethodDescriptor(
  '/promptoverridesources.PromptOverrideSources/DeletePromptOverrideSource',
  grpc.web.MethodType.UNARY,
  proto.promptoverridesources.DeletePromptOverrideSourceRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.promptoverridesources.DeletePromptOverrideSourceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.promptoverridesources.DeletePromptOverrideSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.promptoverridesources.PromptOverrideSourcesClient.prototype.deletePromptOverrideSource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/promptoverridesources.PromptOverrideSources/DeletePromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_PromptOverrideSources_DeletePromptOverrideSource,
      callback);
};


/**
 * @param {!proto.promptoverridesources.DeletePromptOverrideSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.promptoverridesources.PromptOverrideSourcesPromiseClient.prototype.deletePromptOverrideSource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/promptoverridesources.PromptOverrideSources/DeletePromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_PromptOverrideSources_DeletePromptOverrideSource);
};


module.exports = proto.promptoverridesources;

